import { isBefore, isSameDay, isSameMonth, isSameYear } from 'date-fns'

const sortInProgress = (list: ManifestationResponse[]) =>
  list.sort((a, b) => (isBefore(new Date(a.dateOuverturePublic), new Date(b.dateOuverturePublic)) ? 1 : -1))

const sortIncoming = (list: ManifestationResponse[]) =>
  list.sort((a, b) => (isBefore(new Date(a.dateDebutMontage), new Date(b.dateDebutMontage)) ? 1 : -1))

const sortToBeClosed = (list: ManifestationResponse[]) =>
  list.sort((a, b) => (isBefore(new Date(a.dateFermeturePublic), new Date(b.dateFermeturePublic)) ? 1 : -1))

const orderManifestations = (manifestations: ManifestationResponse[]): OrderedManifestations => {
  const ordered = manifestations.reduce(
    (acc, cur) => {
      const status = manifestationStatus(cur)

      acc[status].push(cur)

      return acc
    },
    { inProgress: [], incoming: [], toBeClosed: [] } as OrderedManifestations
  )

  const result = {
    inProgress: sortInProgress(ordered.inProgress),
    incoming: sortIncoming(ordered.incoming),
    toBeClosed: sortToBeClosed(ordered.toBeClosed),
  }

  return result
}

const manifestationStatus = (manifestation: ManifestationResponse): ManifestationStatus => {
  const now = Date.now()

  const started = isBefore(new Date(manifestation.dateDebutMontage), now)
  const over = isBefore(new Date(manifestation.dateFinDemontage), now)

  if (started) {
    if (over) {
      return 'toBeClosed'
    } else {
      return 'inProgress'
    }
  } else {
    return 'incoming'
  }
}

const manifestationDate = (manifestation: ManifestationResponse, i18n: I18nState) => {
  const start = new Date(manifestation.dateOuverturePublic)
  const end = new Date(manifestation.dateFermeturePublic)

  if (isSameDay(start, end)) {
    return i18n.t('screens.site.eventDate.sameDay', { date: start })
  }
  if (isSameMonth(start, end)) {
    return i18n.t('screens.site.eventDate.sameMonth', { start, end })
  }
  if (isSameYear(start, end)) {
    return i18n.t('screens.site.eventDate.sameYear', { start, end })
  }
  return i18n.t('screens.site.eventDate.dates', { start, end })
}

const orderManifestationsByMonth = (list: ManifestationResponse[], mostRecentFirst?: boolean) =>
  list
    .reduce((acc, cur) => {
      const index = acc.findIndex((section) => isSameMonth(new Date(section.section), new Date(cur.dateDebutMontage)))
      if (index > -1) {
        acc[index].manifestations.push(cur)
        return acc
      } else {
        return [...acc, { section: cur.dateDebutMontage, manifestations: [cur] }]
      }
    }, [] as ManifestationsSection[])
    .sort((a, b) => (isBefore(new Date(a.section), new Date(b.section)) ? 1 : -1) * (mostRecentFirst ? -1 : 1))

const manifestationHasActions = (manifestation: ManifestationResponse) =>
  /*
  TODO : mettre en place la règle
  possède encore des demandes ouvertes ET état des lieux de sortie pas encore finalisé
  */
  false

const getOnlyManifestation = (manifestations: OrderedManifestations): ManifestationResponse | undefined => {
  const list = [manifestations.inProgress, manifestations.incoming, manifestations.toBeClosed].find(
    (manifs) => manifs.length === 1
  )
  return list ? list[0] : undefined
}

const findManifestation = ({ inProgress, incoming, toBeClosed }: OrderedManifestations, id?: string) => {
  return id
    ? inProgress.find((itm) => itm.id === id) ||
        toBeClosed.find((itm) => itm.id === id) ||
        incoming.find((itm) => itm.id === id)
    : undefined
}

export {
  orderManifestations,
  manifestationDate,
  orderManifestationsByMonth,
  manifestationHasActions,
  manifestationStatus,
  getOnlyManifestation,
  findManifestation,
}
